import React from 'react';
// selectors
import { useLanguageSelectors } from 'src/@app/reducers/languageReducer';
// components
import { BlockHeader, DescriptionList, Card, CardHeader } from '@ems/client-design-system';
// utils
import {
  displayTemperature,
  displayHumidity,
  displayPressure,
  displayWindSpeed,
  displayWindDirection,
  displayVisibility,
  displayCeiling,
} from 'src/utils/unitsOfMeasurement';
export const OperationWeatherContainer = ({ data }) => {
  const hasData: boolean = (typeof data !== 'undefined' || !data) && !!Object.keys(data).length;
  // Translation
  const languageSelectors = useLanguageSelectors();
  const {
    components: {
      weatherDetails: { title },
    },
    fields: {
      periodicWeather: {
        temperature: tempTitle,
        relativeHumidity: humidityTitle,
        atmosphericPressure: pressureTitle,
        windSpeed: speedTitle,
        windDirection: directionTitle,
        visibility: visibilityTitle,
        ceiling: ceilingTitle,
      },
    },
  } = languageSelectors.getLanguage();
  // data
  const {
    precipitation,
    cloudCover,
    temperature,
    relativeHumidity,
    atmosphericPressure,
    windSpeed,
    windDirection,
    visibility,
    ceiling,
  } = data;

  const checkValueExists = (
    value: string | number,
    converter = (value: string | number): string => `${value}`
  ) => {
    return typeof value === 'undefined' || !value ? null : converter(value);
  };

  const weatherDescription = hasData
    ? checkValueExists(precipitation)
      ? `${precipitation}. ${cloudCover}`
      : `${cloudCover}`
    : ``;
  const items: any = [
    {
      title: tempTitle,
      description: displayTemperature(temperature),
    },
    {
      title: humidityTitle,
      description: displayHumidity(relativeHumidity),
    },
    {
      title: pressureTitle,
      description: displayPressure(atmosphericPressure),
    },
    {
      title: speedTitle,
      description: displayWindSpeed(windSpeed),
    },
    {
      title: directionTitle,
      description: displayWindDirection(windDirection),
    },
    {
      title: visibilityTitle,
      description: displayVisibility(visibility),
    },
    {
      title: ceilingTitle,
      description: displayCeiling(ceiling),
    },
  ];

  return (
    <div className="block">
      <BlockHeader title={title} loading={!hasData} />
      <Card>
        <CardHeader description={weatherDescription} loading={!hasData} />
        <DescriptionList
          className={weatherDescription ? `second-row-info` : ``}
          items={items}
          loading={!hasData}
        />
      </Card>
    </div>
  );
};
